import { getTopFormulationListData, getHitConceptListData, getNewConceptListData, getSearchListData, getTabListData, getTopTradeListData, getSwiperListData, getDetailListData, getLastUpdateTime, getHighLight } from '@/axios/api/conceptCollections.js'

// const UPDATE_SWIPERLISTDATA = 'UPDATE_SWIPERLISTDATA'
const UPDATE_NEWCONCEPTLISTDATA = 'UPDATE_NEWCONCEPTLISTDATA'
const UPDATE_HITCONCEPTLISTDATA = 'UPDATE_HITCONCEPTLISTDATA'
const UPDATE_TOPFORMULATIONLISTDATA = 'UPDATE_TOPFORMULATIONLISTDATA'
const UPDATE_DETAILLISTDATA = 'UPDATE_DETAILLISTDATA'
const UPDATE_TOPTRADEDATA = 'UPDATE_TOPTRADEDATA'
const UPDATE_NEWTABLISTDATA = 'UPDATE_NEWTABLISTDATA'
const UPDATE_OLDTABLISTDATA = 'UPDATE_OLDTABLISTDATA'
const UPDATE_NEWLOADING = 'UPDATE_NEWLOADING'
const UPDATE_SEARCHDATA = 'UPDATE_SEARCHDATA'
const UPDATE_HIGH_LIGHT = 'UPDATE_HIGH_LIGHT'
// const UPDATE_PARAMS = 'UPDATE_PARAMS'
// 分页 总数
const UPDATE_TOTAL = 'UPDATE_TOTAL'
// 分页 查询
const UPDATE_SEARCH = 'UPDATE_SEARCH'

const state = {
  newLoading: false,
  // swiperListData: [],
  newConceptListData: [],
  hitConceptListData: [],
  topFormulationListData: [],
  // 分页 参数
  pager: {
    current: 1,
    size: 12,
    total: 0
  },
  // 分页 查询
  pageParam: {

  },
  param: {
    size: 10,
    current: 1,
    desc: ['id']
  },
  params: {
    current: 1,
    size: 10,
    desc: ['position_id']
    // positionGroup: 'New'
  },
  detailListData: {
    conceptMainInfo: {}
  },
  topTradeData: [],
  searchData: [],
  // detailParams: {
  //   id: 1
  // },
  topTradeParams: {
    current: 1,
    size: 10,
    desc: ['create_time']
  },
  tabNewListData: [],
  tabOldListData: [],
  highLight: false
  // tabListNewParams: {
  //   type: 'New',
  //   current: 1,
  //   size: 10,
  //   desc: ['weight']

  // },
  // tabListOldParams: {
  //   type: 'Old',
  //   current: 1,
  //   size: 10,
  //   desc: ['weight']

  // }
}
const getters = {
  // swiperListData: state => state.swiperListData,
  newConceptListData: state => state.newConceptListData,
  detailListData: state => state.detailListData,
  topTradeData: state => state.topTradeData,
  tabNewListData: state => state.tabNewListData,
  tabOldListData: state => state.tabOldListData,
  // 分页
  pager: state => state.pager,
  param: state => state.param,
  newLoading: state => state.newLoading,
  searchData: state => state.searchData,
  hitConceptListData: state => state.hitConceptListData,
  topFormulationListData: state => state.topFormulationListData,
  highLight: state => state.highLight
}

const mutations = {
  // [UPDATE_SWIPERLISTDATA] (state, swiperListData) {
  //   state.swiperListData = swiperListData
  // },
  [UPDATE_NEWCONCEPTLISTDATA] (state, newConceptListData) {
    state.newConceptListData = newConceptListData
  },
  [UPDATE_HITCONCEPTLISTDATA] (state, hitConceptListData) {
    state.hitConceptListData = hitConceptListData
  },
  [UPDATE_DETAILLISTDATA] (state, detailListData) {
    state.detailListData = detailListData
  },
  [UPDATE_TOPTRADEDATA] (state, topTradeData) {
    state.topTradeData = topTradeData
  },
  [UPDATE_NEWTABLISTDATA] (state, tabNewListData) {
    state.tabNewListData = tabNewListData
  },
  [UPDATE_OLDTABLISTDATA] (state, tabOldListData) {
    state.tabOldListData = tabOldListData
  },
  [UPDATE_NEWLOADING] (state, newLoading) {
    state.newLoading = newLoading
  },
  [UPDATE_SEARCHDATA] (state, searchData) {
    state.searchData = searchData
  },
  [UPDATE_TOPFORMULATIONLISTDATA] (state, topFormulationListData) {
    state.topFormulationListData = topFormulationListData
  },
  // 分页
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  // 分页 查询
  [UPDATE_SEARCH] (state, { pager, pageParam }) {
    state.pager = pager
    if (pageParam) state.pageParam = pageParam
  },
  [UPDATE_HIGH_LIGHT] (state, highLight) {
    state.highLight = highLight
  }
  // [UPDATE_TABLEUPLOADDATA] (state, tableUploadData) {
  //   state.tableUploadData = tableUploadData
  // },
  // [UPDATE_PARAMS] (state, params) {
  //   state.params = { ...state.params, params }
  // }
}

const actions = {
  /**
   *
   * @param {*} { commit }
   * @param {*} params
   */
  async getNewConceptListDataApi ({ commit }) {
    try {
      let { data: res } = await getNewConceptListData()
      commit(UPDATE_NEWCONCEPTLISTDATA, res || {})
    } catch (e) {
      commit(UPDATE_NEWCONCEPTLISTDATA, {})
    }
  },
  async getHitConceptListDataApi ({ commit }) {
    let { data: res } = await getHitConceptListData()
    commit(UPDATE_HITCONCEPTLISTDATA, res)
  },
  async getTopFormulationListDataApi ({ commit }) {
    let { data: res } = await getTopFormulationListData()
    commit(UPDATE_TOPFORMULATIONLISTDATA, res)
  },

  // async getSwiperListDataApi ({ state, commit }) {
  //   let { data: res } = await getSwiperListData({...state.params, positionGroup: 'New'})
  //   commit(UPDATE_SWIPERLISTDATA, res)
  // },
  /**
   *
   * @param {*} { commit }
   * @param {*} params
   */
  // async getSwiperListDataApi ({ commit }, params)
  async getDetailListDataApi ({ commit }, params) {
    // const { tableSource, size, current, desc } = { ...params }
    let { data: res } = await getDetailListData({...params})
    // console.log(res.data);
    commit(UPDATE_DETAILLISTDATA, res)
    commit(UPDATE_TOTAL, res.total)
  },

  /**
   *
   * @param {*} { commit }
   * @param {*} params
   */
  async getTopTradeListDataApi ({ commit }) {
    // const { tableSource, size, current, desc } = { ...params }
    let { data: res } = await getTopTradeListData()
    // console.log(res.data);
    commit(UPDATE_TOPTRADEDATA, res)
  },
  /**
   *
   * @param {*} { commit }
   * @param {*} params
   */
  async getSearchListDataApi ({ state, commit }, param) {
    let { data: res } = await getSearchListData({param})
    // console.log(res.data);
    commit(UPDATE_SEARCHDATA, res)
  },
  // 清空搜索条件
  clearSearchApi ({state, commit}) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {
      ...state.params,
      id: '',
      account: '',
      phone: '',
      email: '',
      roleId: '',
      dataStatus: ''
    }
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 分页 设置page
  setPagerApi ({commit}, pager) {
    console.log(pager)
    commit(UPDATE_SEARCH, {pager})
  },
  /**
   * tab new切换
   * @param {*} { commit }
   * @param {*} params
   */
  async getNewTabListDataApi ({ state, commit }, params) {
    commit(UPDATE_NEWLOADING, true)
    try {
      let { data: res } = await getTabListData({...params})
      commit(UPDATE_NEWTABLISTDATA, res.search || [])
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {
    }
    commit(UPDATE_NEWLOADING, false)
  },
  /**
   * tab old切换
   * @param {*} { commit }
   * @param {*} params
   */
  async getOldTabListDataApi ({ state, commit }, params) {
    commit(UPDATE_NEWLOADING, true)
    try {
      let { data: res } = await getTabListData({...params})
      commit(UPDATE_OLDTABLISTDATA, res)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) {
    }
    commit(UPDATE_NEWLOADING, false)
  },
  async getLastUpdateTimeApi ({ state, commit }, params) {
    try {
      let { data: res } = await getLastUpdateTime({...params})
      return res
    } catch (e) {
      return {}
    }
  },
  async getHighLightApi ({ state, commit }, params) {
    try {
      // {
      //   current: 1,
      //   desc: ['weight'],
      //   size: 1,
      //   type: 'New'
      // }
      let { data: res } = await getHighLight()
      commit(UPDATE_HIGH_LIGHT, res.list[0] || false)
    } catch (e) {
      return false
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/conceptCollection.js